module.exports = __webpack_public_path__ + "img/tick_white.6b37c199.svg";